import Theme1Scene from './theme1';
import Theme2Scene from './theme2';
const defaultParams = {
  data: null,
  theme: 1, //主题
  autoShow: true, //自动打开
  defaultSceneName: null, //初始化时激活的场景
  onPanoClick: function() {}, //pano点击事件
};

class SceneList {
  constructor(props) {
    const { wrapper, ...params } = props;
    this.wrapper = wrapper;
    this.params = {
      ...defaultParams,
      ...params,
    };
    this._init();
  }
  _init() {
    const { theme, autoShow } = this.params;
    switch (theme) {
      case 1:
        this._createTheme1();
        break;
      case 2:
        this._createTheme2();
      default:
        break;
    }
  }
  _createTheme1() {
    const { data, onPanoClick, autoShow, defaultSceneName } = this.params;
    this.sceneList = new Theme1Scene({
      data,
      defaultSceneName,
      wrapper: this.wrapper,
      autoShow,
      onPanoClick,
    });
  }
  _createTheme2() {
    const { data, onPanoClick, autoShow } = this.params;
    this.sceneList = new Theme2Scene({
      data,
      wrapper: this.wrapper,
      autoShow,
      onPanoClick,
    });
  }
  changeSceneByName(name) {
    this.sceneList.changeSceneByName(name);
  }
  show() {
    this.sceneList.show();
  }
  hide() {
    this.sceneList.hide();
  }
  toggle() {
    this.sceneList.toggle();
  }
}

export default SceneList;
